import Transform from '@ember-data/serializer/transform';
import deeplyTrackedObject from 'garaje/utils/deeply-tracked-object';
import { TrackedObject } from 'tracked-built-ins';

export default class DeeplyTrackedObjectTransform extends Transform {
  deserialize(value: Record<string, unknown> | null | undefined): object {
    if (!value) return new TrackedObject();
    return deeplyTrackedObject(value);
  }

  serialize(value: TrackedObject | null | undefined): object | null {
    return value ?? null;
  }
}
